import { Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { ConceptInvoicingTypeEnums } from 'src/app/enum/concept-invoicing-enums';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { TaxTableModalModel } from 'src/app/models/tables/wallet/tax-table-modal.model';
import { ConceptInvoicingService } from 'src/app/services/invoicing/concept-invoicing.service';
import { TaxService } from 'src/app/services/management/tax.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { InvoicingModelDetailModel } from '../../../../models/invoicing/invoicing-model-detail.model';
import { InvoicingModelModel } from '../../../../models/invoicing/invoicing-model.model';
import { InvoicingModelDetailService } from './../../../../services/invoicing/invoicing-model-detail.service';

@Component({
  selector: 'app-register-invoicing-model-detail',
  templateUrl: './register-invoicing-model-detail.component.html',
  styleUrls: ['./register-invoicing-model-detail.component.scss'],
  standalone: false
})
export class RegisterInvoicingModelDetailComponent implements OnInit, OnChanges, OnDestroy {

  @ViewChild('taxIvaSelection') taxIvaSelectionModalComponent?: CustomModalComponent | null = null;
  @ViewChild('taxRtfSelection') taxRtfSelectionModalComponent?: CustomModalComponent | null = null;

  @Input() invoicingModelDetailContract: InvoicingModelDetailModel = new InvoicingModelDetailModel();
  @Input() invoicingModelModel: InvoicingModelModel = new InvoicingModelModel();
  @Output() isFormView = new EventEmitter<boolean>();
  @Output() updateListDetail = new EventEmitter<boolean>();

  ascendantTax: boolean = true;
  codeNameTaxIva: string = '';
  codeNameTaxRtf: string = '';
  columnSortTax: string | null = null;
  dataTax: PagedResponseModel<TaxTableModalModel> = new PagedResponseModel<TaxTableModalModel>();
  filtersTax: ColumnResponseModel[] = [];
  formInvoicingModelDetail: FormGroup = new FormGroup({});
  headerTax: ColumnResponseModel[] = [];
  inputsForTaxSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: true,
    showRecover: true,
    isMultipleSelect: false,
    filters: [],
  });
  invoicingModelDetailId: number = 0;
  isIva: boolean = false;
  listConceptInvoicing: any[] = [];
  limitTax: number = 10;
  output$ = new Subject<any>();
  pageTax: number = 1;
  percentIva: number = 0;
  percentRFte: number = 0;
  subscription: Subscription;
  taxIvaId: number = 0;
  taxRtfId: number = 0;
  componentTableSelection = CustomTableSelectComponent;
  @Input() conceptInvoicingType: number = ConceptInvoicingTypeEnums.venta;

  constructor(private conceptInvoicingService: ConceptInvoicingService,
    private formBuilder: FormBuilder,
    private invoicingModelDetailService: InvoicingModelDetailService,
    private router: Router,
    private taxService: TaxService,
    private toastHandlerService: ToastHandlerService) {
    this.validateForm(this.invoicingModelDetailContract);
  }

  async ngOnInit() {
    this.validateForm(this.invoicingModelDetailContract);
    if (this.conceptInvoicingType === ConceptInvoicingTypeEnums.compra) {
      this.listConceptInvoicing = await firstValueFrom(this.conceptInvoicingService.getAllPurchaseConceptsForSelectAsync());
    } else {
      this.listConceptInvoicing = await firstValueFrom(this.conceptInvoicingService.getAllConceptsInvoicingForSelectAsync());
    }
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChange(payload, this.isIva);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnChanges(changes: SimpleChanges) {
    const invoicingModelDetailContract = changes['invoicingModelDetailContract'];
    if (invoicingModelDetailContract) {
      if (this.invoicingModelDetailContract.invoicingModelDetailId === 0) {
        this.invoicingModelDetailId = 0;
        this.taxIvaId = 0;
        this.taxRtfId = 0;
        this.codeNameTaxIva = '';
        this.codeNameTaxRtf = '';
        this.percentIva = 0;
        this.percentRFte = 0;
        this.invoicingModelDetailContract = new InvoicingModelDetailModel();
      } else {
        this.getTax(this.invoicingModelDetailContract.ivaTaxId, true);
        this.getTax(this.invoicingModelDetailContract.rtfTaxId, false);
        this.invoicingModelDetailId = this.invoicingModelDetailContract.invoicingModelDetailId;
      }
      this.validateForm(this.invoicingModelDetailContract);
    }
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  clearForm() {
    this.invoicingModelDetailId = 0;
    this.taxIvaId = 0;
    this.taxRtfId = 0;
    this.codeNameTaxIva = '';
    this.codeNameTaxRtf = '';
    this.percentIva = 0;
    this.percentRFte = 0;
    this.invoicingModelDetailContract = new InvoicingModelDetailModel();
    this.validateForm(this.invoicingModelDetailContract);
    this.isFormView.emit(false);
  }

  async getColumnsTax() {
    try {
      if (this.headerTax.length === 0) {
        this.headerTax = await firstValueFrom(this.invoicingModelDetailService.getColumnsForTaxes());
      }
    } catch (error) {
      console.error('Error al obtener las columnas para los impuestos.', error);
    }
  }

  async getInvoicingModelDetailByKeys(conceptInvoicingId: number | null) {
    if (conceptInvoicingId !== 0 && conceptInvoicingId !== null) {
      try {
        this.invoicingModelDetailContract = await firstValueFrom(this.invoicingModelDetailService.getInvoicingModelDetailByKeys(
          this.invoicingModelModel.invoicingModelId, conceptInvoicingId, this.invoicingModelDetailContract)
        );
        this.invoicingModelDetailId = this.invoicingModelDetailContract.invoicingModelDetailId;
        this.getTax(this.invoicingModelDetailContract.ivaTaxId, true);
        this.getTax(this.invoicingModelDetailContract.rtfTaxId, false);
        this.validateForm(this.invoicingModelDetailContract);
      } catch (error) {
        console.error('Error al obtener el detalle del modelo de facturación por llaves.', error);
      }
    } else {
      this.percentIva = 0;
      this.percentRFte = 0;
      this.codeNameTaxIva = '';
      this.codeNameTaxRtf = '';
      this.formInvoicingModelDetail.controls['conceptInvoicingId'].patchValue(0);
      this.formInvoicingModelDetail.controls['ivaTaxId'].patchValue(0);
      this.formInvoicingModelDetail.controls['rtfTaxId'].patchValue(0);
    }
  }

  async getTax(taxId: number | null, isIva: boolean) {
    if (taxId != null && taxId != 0) {
      const tax = await firstValueFrom(this.taxService.getTaxById(taxId));
      if (tax) {
        if (isIva) {
          this.taxIvaId = taxId;
          this.codeNameTaxIva = `${tax.code} - ${tax.name}`;
          this.percentIva = tax.rate;
          this.formInvoicingModelDetail.controls['ivaTaxId'].patchValue(taxId);
        } else {
          this.taxRtfId = taxId;
          this.codeNameTaxRtf = `${tax.code} - ${tax.name}`;
          this.percentRFte = tax.rate;
          this.formInvoicingModelDetail.controls['rtfTaxId'].patchValue(taxId);
        }
      } else {
        this.codeNameTaxIva = 'Error al buscar el elemento. Por favor refresque la página.';
        this.codeNameTaxRtf = 'Error al buscar el elemento. Por favor refresque la página.';
        return;
      }
    } else {
      if (isIva) {
        this.taxIvaId = 0;
        this.codeNameTaxIva = '';
      } else {
        this.taxRtfId = 0;
        this.codeNameTaxRtf = '';
      }
    }
  }

  async getTaxesForInvoicingModelDetail(isIva: boolean) {
    try {
      this.dataTax = await firstValueFrom(
        this.invoicingModelDetailService.getTaxesForDetailsAsync(
          isIva,
          this.pageTax,
          this.limitTax,
          this.columnSortTax,
          this.ascendantTax,
          this.filtersTax
        )
      );
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los impuestos.', error);
    }
  }

  async handleSelectedItem(selectedItem: any, iva: boolean) {
    if (selectedItem && selectedItem.length === 1) {
      this.isFormView.emit(true);
      this.getTax(parseInt(selectedItem[0]?.taxId), iva);
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filtersTax = this.removeDuplicates(filters);
    this.filtersTax.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async onPageChange(event: {
    page: number;
    pageSize: number;
    sortField: string | undefined;
    sortOrder: number;
  }, isIva: boolean) {
    this.pageTax = event.page;
    this.limitTax = event.pageSize;
    this.columnSortTax = event.sortField || null;
    this.ascendantTax = event.sortOrder === 1;
    this.getTaxesForInvoicingModelDetail(isIva);
  }

  async openTaxSelectionModal(isIva: boolean) {
    this.filtersTax = [];
    this.isIva = isIva;
    this.updateInputs();
    await Promise.all([
      await this.getColumnsTax(),
      this.getTaxesForInvoicingModelDetail(isIva),
    ]);

    if (isIva) {
      if (this.taxIvaSelectionModalComponent && this.headerTax) {
        this.taxIvaSelectionModalComponent.show();
      } else {
        this.toastHandlerService.showToast(
          'error',
          'No se pudieron cargar los impuestos de tipo IVA. Por favor, inténtelo de nuevo.'
        );
      }
    } else {
      if (this.taxRtfSelectionModalComponent && this.headerTax) {
        this.taxRtfSelectionModalComponent.show();
      } else {
        this.toastHandlerService.showToast(
          'error',
          'No se pudieron cargar los impuestos de tipo RFte. Por favor, inténtelo de nuevo.'
        );
      }
    }
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (
      valueFilter === null ||
      valueFilter === undefined ||
      valueFilter === '' ||
      valueFilter === 0
    ) {
      this.filtersTax = this.filtersTax.filter(
        (f) => f.propertyName !== propertyName
      );
    } else {
      const existingFilter = this.filtersTax.find(
        (f) => f.propertyName === propertyName
      );
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter(
      (value, index, self) =>
        index ===
        self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async send() {
    Object.keys(this.formInvoicingModelDetail.controls).forEach((key) => {
      const control = this.formInvoicingModelDetail.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });

    if (this.formInvoicingModelDetail.valid) {
      const modelInvoicingModelDetail = this.formInvoicingModelDetail.getRawValue() as InvoicingModelDetailModel;
      modelInvoicingModelDetail.invoicingModelId = this.invoicingModelModel.invoicingModelId;

      if (modelInvoicingModelDetail.alterConcept?.trim() === "") modelInvoicingModelDetail.alterConcept = null;
      if (modelInvoicingModelDetail.saleAccount?.trim() === "") modelInvoicingModelDetail.saleAccount = null;
      if (modelInvoicingModelDetail.saleDevolutionAccount?.trim() === "") modelInvoicingModelDetail.saleDevolutionAccount = null;

      if (this.invoicingModelDetailId === 0) {
        try {
          if (this.conceptInvoicingType === ConceptInvoicingTypeEnums.compra) {
            modelInvoicingModelDetail.alterConcept = null;
            modelInvoicingModelDetail.swAiu = false;
            modelInvoicingModelDetail.invoiceNumber = 1;
            modelInvoicingModelDetail.saleAccount = null;
            modelInvoicingModelDetail.saleDevolutionAccount = null;
            await firstValueFrom(this.invoicingModelDetailService.createPurchaseModelDetail(modelInvoicingModelDetail));
            this.updateListDetail.emit(true);
            this.toastHandlerService.showToast('success', 'El detalle del modelo de compra fue creado exitosamente.');
          } else {
            await firstValueFrom(this.invoicingModelDetailService.createInvoicingModelDetail(modelInvoicingModelDetail));
            this.updateListDetail.emit(true);
            this.toastHandlerService.showToast('success', 'El detalle del modelo de facturación fue creado exitosamente.');
          }
          this.clearForm();
        } catch (error) {
          console.error('Error al crear el detalle del modelo.', error);
        }
      } else {
        this.invoicingModelDetailContract.alterConcept = modelInvoicingModelDetail.alterConcept;
        this.invoicingModelDetailContract.swAiu = modelInvoicingModelDetail.swAiu;
        this.invoicingModelDetailContract.invoiceNumber = modelInvoicingModelDetail.invoiceNumber;
        this.invoicingModelDetailContract.saleAccount = modelInvoicingModelDetail.saleAccount;
        this.invoicingModelDetailContract.saleDevolutionAccount = modelInvoicingModelDetail.saleDevolutionAccount;
        this.invoicingModelDetailContract.ivaTaxId = modelInvoicingModelDetail.ivaTaxId;
        this.invoicingModelDetailContract.rtfTaxId = modelInvoicingModelDetail.rtfTaxId;

        const message = this.conceptInvoicingType === ConceptInvoicingTypeEnums.compra ? 'compra' : 'facturación.';
        try {
          if (this.conceptInvoicingType === ConceptInvoicingTypeEnums.compra) {
            this.invoicingModelDetailContract.alterConcept = null;
            this.invoicingModelDetailContract.swAiu = false;
            this.invoicingModelDetailContract.invoiceNumber = 1;
            this.invoicingModelDetailContract.saleAccount = null;
            this.invoicingModelDetailContract.saleDevolutionAccount = null;
            await firstValueFrom(this.invoicingModelDetailService.updatePurchaseModelDetail(this.invoicingModelDetailContract));
          } else {
            await firstValueFrom(this.invoicingModelDetailService.updateInvoicingModelDetail(this.invoicingModelDetailContract));
          }
          this.updateListDetail.emit(true);
          this.toastHandlerService.showToast('success', `El detalle del modelo de ${message} fue modificado exitosamente.`);
          this.clearForm();
        } catch (error) {
          console.error(`Error al actualizar el detalle del modelo de ${message}.`, error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      conceptInvoicingId: {
        required: 'El campo Concepto Fra. es obligatorio.',
        min: 'Debe seleccionar un Concepto Fra. válido.',
      },
      alterConcept: {
        maxLength: 'El campo Concepto Alt. no puede superar 20 caracteres.',
      },
      invoiceNumber: {
        required: 'El campo Nro.Factura es obligatorio.',
        min: 'Debe ingresar un Nro.Factura igual o superior a 1.',
      },
      saleAccount: {
        maxLength: 'El campo Cuenta Venta no puede superar 10 caracteres.',
      },
      saleDevolutionAccount: {
        maxLength: 'El campo Cuenta Venta no puede superar 10 caracteres.',
      },
      ivaTaxId: {
        required: 'El campo IVA es obligatorio.',
        min: 'Debe seleccionar un IVA válido.',
      },
      rtfTaxId: {
        required: 'El campo RFte es obligatorio.',
        min: 'Debe seleccionar un RFte válido.',
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formInvoicingModelDetail.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  updateInputs() {
    this.inputsForTaxSelection$.next({
      headers: this.headerTax,
      data: this.dataTax,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: false,
      filters: this.filtersTax,
    });
  }

  validateForm(invoicingModelDetail: InvoicingModelDetailModel) {
    const isVenta = this.conceptInvoicingType === ConceptInvoicingTypeEnums.venta;

    this.formInvoicingModelDetail = this.formBuilder.group({
      conceptInvoicingId: [invoicingModelDetail.conceptInvoicingId, [Validators.required, Validators.min(1)]],
      alterConcept: [invoicingModelDetail.alterConcept, isVenta ? [Validators.maxLength(20)] : []],
      swAiu: [invoicingModelDetail.swAiu],
      invoiceNumber: [invoicingModelDetail.invoiceNumber, isVenta ? [Validators.required, Validators.min(1)] : []],
      saleAccount: [invoicingModelDetail.saleAccount, isVenta ? [Validators.maxLength(10)] : []],
      saleDevolutionAccount: [invoicingModelDetail.saleDevolutionAccount, isVenta ? [Validators.maxLength(10)] : []],
      ivaTaxId: [invoicingModelDetail.ivaTaxId, [Validators.required, Validators.min(1)]],
      rtfTaxId: [invoicingModelDetail.rtfTaxId, [Validators.required, Validators.min(1)]]
    });
  }
}